import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var formModalBehavior = function formModalBehavior() {
  Alpine.data('formModalBehavior', function () {
    return {
      $modalOpenButton: false,
      $modalCloseButton: false,
      $modalBackground: false,
      $modal: false,
      init: function init() {
        this.$modal = this.$el;
        this.$modalOpenButton = document.querySelector('#a-pricing__enquiry > button');
        this.$modalCloseButton = document.querySelector('.a-form-modal__close');
        this.setBlurButton();
      },
      setBlurButton: function setBlurButton() {
        if (this.$modalOpenButton) {
          // Add event listener to open modal button
          this.$modalOpenButton.addEventListener('click', this.blurHeader); // eslint-disable-next-line func-names

          this.$modalOpenButton.addEventListener('keydown', function (e) {
            if (e.keyCode === 13) {
              this.blurHeader();
            }
          });
        }

        if (this.$modalCloseButton) {
          // Add event listener to close modal button
          this.$modalCloseButton.addEventListener('click', this.unblurHeader); // eslint-disable-next-line func-names

          this.$modalCloseButton.addEventListener('keydown', function (e) {
            if (e.keyCode === 13) {
              this.unblurHeader();
            }
          });
        }
      },
      blurHeader: function blurHeader() {
        var header = document.querySelector('header');
        header.parentElement.classList.add('modal-open');
        this.$modalBackground = document.querySelector('div.a-form-modal_open');

        if (this.$modalBackground) {
          // eslint-disable-next-line func-names
          this.$modalBackground.addEventListener('click', function () {
            var siteHeader = document.querySelector('header');
            siteHeader.parentElement.classList.remove('modal-open');
          });
        }

        if (breakpoint.isMobile) {
          window.scrollTo(0, 0);
          var modalContainer = document.querySelector('.a-form-modal');
          var siteHeader = document.getElementById('block-site-header');
          var siteBreadcrumbs = document.getElementById('block-breadcrumbs');
          var size = (siteHeader.offsetHeight + siteBreadcrumbs.offsetHeight) * -1;
          modalContainer.style.top = "".concat(size, "px");
        }
      },
      unblurHeader: function unblurHeader() {
        var header = document.querySelector('header');
        header.parentElement.classList.remove('modal-open');
      }
    };
  });
};